
export default {
    name: 'top-menu',
    template: require('./TopMenu.html'),
    data() {
        return {
            address: '',
            checksumAddress: '',
            lowercased: '',
            hex: '',
            link: ''
        }
    },
    created() {
    },
    methods: {
    }
}
